import { render, staticRenderFns } from "./marking.vue?vue&type=template&id=7796dc2c&scoped=true&"
import script from "./marking.vue?vue&type=script&lang=js&"
export * from "./marking.vue?vue&type=script&lang=js&"
import style0 from "./marking.vue?vue&type=style&index=0&id=7796dc2c&lang=scss&scoped=true&"
import style1 from "./marking.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7796dc2c",
  null
  
)

export default component.exports